import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import {
  faDownload,
  faPlus,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import swal from "sweetalert";

import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import cellEditFactory from "react-bootstrap-table2-editor";
import filterFactory from "react-bootstrap-table2-filter";

import {
  getFieldEntryByDate,
  getFieldIssueWorkOrderExcelDownload,
  getFieldVisitPdfDownload,
  getFieldWorkOrderDetailsLExcel,
  getWorkOrderFieldIssueList,
  getfieldissueDispenserSerialNumber,
  getFieldWorkOrderDetailsAllPdf,
} from "../../Service/AllWorkOrderFieldIssueAPI";

import * as Paginator from "react-bootstrap-table2-paginator";

export default () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [entries, setEntries] = useState([]);
  const [show, setShow] = useState(false);
  const [isLoaded, setisLoaded] = useState(false);
  const [searchDispenserSerialNumber, setSearchDispenserSerialNumber] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);

  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getFieldIssue();
    // eslint-disable-next-line
  }, []);

  const handlePageChange = async (page) => {
    const selectedPage = page - 1;
    setEntries([]);
    if (fromDate === "" && toDate === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      try {
        setisLoaded(true);
        const result = await getWorkOrderFieldIssueList(
          selectedPage,
          "field visit",
          fkUserId,
          role,
          headers
        );

        if (result?.data?.content?.length) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;

          // Add serial number
          const updatedData = data.map((item, index) => ({
            ...item,
            id: totalSize + index + 1,
          }));

          setEntries(updatedData);
          setPageCount(result.data.totalPages);
          setTotaloffset(totalSize);
        } else {
          // swal("Sorry", "Work order field visit data is not present", "warning");
        }
      } catch (error) {
        console.error(error);
      } finally {
        setisLoaded(false);
      }
    } else if (fromDate && toDate) {
      try {
        setisLoaded(true);
        const result = await getFieldEntryByDate(
          selectedPage,
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );

        if (result?.data?.content?.length) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;

          const updatedData = data.map((item, index) => ({
            ...item,
            id: totalSize + index + 1,
          }));

          setEntries(updatedData);
          setPageCount(result.data.totalPages);
          setTotaloffset(totalSize);
          setTotalCount(result.data.totalElements);
        } else {
          setEntries([]);
          setPageCount(0);
          setTotalCount(0);
          swal(
            "Sorry",
            "Work order field visit data is not present for selected date",
            "warning"
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        setisLoaded(false);
      }
    } else {
      swal("Failed", "Please select date", "error");
    }
  };

  const getFieldIssue = async () => {
    try {
      setisLoaded(true);
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      const result = await getWorkOrderFieldIssueList(
        currentPage,
        "field visit",
        fkUserId,
        role,
        headers
      );

      if (result?.data?.content?.length) {
        const data = result.data.content;
        const totalSize = result.data.pageable.offset;

        const updatedData = data.map((item, index) => ({
          ...item,
          id: totalSize + index + 1,
        }));

        setEntries(updatedData);
        setPageCount(result.data.totalPages);
        setTotalCount(result.data.totalElements);
        setTotaloffset(totalSize);
      } else {
        setEntries([]);
        setPageCount(0);
        setTotalCount(0);
        // swal("Sorry", "Work order field visit data is not present", "warning");
      }
    } catch (error) {
      console.log(error);
      // swal(
      //   "Failed",
      //   "Something went wrong please check your internet",
      //   "error"
      // );
    } finally {
      setisLoaded(false);
    }
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (toDate && date > toDate) setToDate(null);
  };

  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null);
    } else {
      setToDate(date);
    }
  };

  const getFieldListByDate = async () => {
    if (!fromDate || !toDate) {
      swal("Failed", "Please select date", "error");
      return;
    }
    await handlePageChange(1); // Call handlePageChange for date filtering
  };

  const clearSearch = () => {
    setSearchDispenserSerialNumber('');
    setSearchPerformed(false);
    getFieldIssue();
  };

  const search = async () => {
    if (!searchDispenserSerialNumber) {
      swal("Missing Serial Number", "Please enter the dispenser serial number", "warning").then(() => clearSearch());
      return;
    }

    try {
      const token = sessionStorage.getItem("token");
      const jobType = ["field visit"];
      const headers = { Authorization: `Bearer ${token}` };

      const result = await getfieldissueDispenserSerialNumber(currentPage, searchDispenserSerialNumber, headers, jobType);

      if (result?.length) {
        const sortedData = result.sort((a, b) => b.pkFieldIssueHistoryId - a.pkFieldIssueHistoryId);
        const updatedData = sortedData.map((item, index) => ({ ...item, id: index + 1 }));
        setEntries(updatedData);
        setPageCount(1);
        setTotalCount(updatedData.length);
      } else {
        swal("No Data", "No records found for the given serial number", "info");
        setEntries([]);
      }
    } catch (error) {
      console.error("Search error:", error);
      swal("Failed", "Failed to fetch data, please try again", "error");
    }
  };

  const getFieldIssueExcelDownloadHandler = async () => {
    try {
      if (fromDate && toDate) {
        await getFieldIssueWorkOrderExcelDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
      }
      await getFieldWorkOrderDetailsLExcel();
    } catch (error) {
      console.error("Excel download error:", error);
    }
  };

  const getFieldReportPdfDownloadHandler = async () => {
    try {
      if (fromDate && toDate) {
        await getFieldVisitPdfDownload(
          moment(fromDate).format("YYYY-MM-DD"),
          moment(toDate).format("YYYY-MM-DD")
        );
      } else {
        await getFieldWorkOrderDetailsAllPdf();
      }
    } catch (error) {
      console.error("PDF download error:", error);
      swal("Failed", "failed to download pdf", "error");
    }
  };

  const columns = [
    { dataField: "id", text: "Id" },
    { dataField: "status", text: "Field Job WO Status", editable: false, headerAlign: "left", style: { textTransform: "capitalize", textAlign: 'center' } },
    { dataField: "workOrderSerialNo", text: "Field job WO Sr No", editable: false, headerAlign: "left" },
    { dataField: "generateUniqueDispenserNo", text: "Dispenser Sr No", editable: false, headerAlign: "left" },
    { dataField: "workOrderDate", text: "Work Order Date", editable: false, headerAlign: "left", formatter: (cell) => <>{moment(cell).format("DD-MMM-YYYY")}</> },
    { dataField: "workOrderTime", text: "Wo Created time", editable: false, headerAlign: "left", formatter: (cell) => <>{moment(cell, "hh:mm A").format("hh:mm A")}</> },
    { dataField: "dispenserType", text: "Dispenser Config", editable: false, headerAlign: "left" },
    { dataField: "oprationType", text: "Opration Type", editable: false, headerAlign: "left" },
    { dataField: "subOprationType", text: "SubOpration Type", editable: false, headerAlign: "left" },
    { dataField: "customerName", text: "Customer Name", editable: false, headerAlign: "left" },
    { dataField: "serviceEngineerName", text: "Field Man Name", editable: false, headerAlign: "left" },
    { dataField: "serviceEngineerMobNo", text: "Field Man Mobile No", editable: false, headerAlign: "left" },
    {
      dataField: "description",
      text: "Description",
      editable: false,
      style: { textTransform: "capitalize" },
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && <span className="tooltip-text">{row.description}</span>}
        </div>
      ),
    },
    {
      dataField: "address",
      text: "Site Address",
      editable: false,
      style: { textTransform: "capitalize" },
      formatter: (cell, row) => {
  const address = cell || "";

  return (
    <div className="tooltip-container">
      <div className="truncated-text">{address || "-"}</div>
      {address.length > 20 && (
        <span className="tooltip-text">{address}</span>
      )}
    </div>
  );
}

    },
    { dataField: "siteType", text: "Site Type", editable: false, headerAlign: "left" },
    { dataField: "timeTaken", text: "Time Taken", headerAlign: "left" },
    { dataField: "whoDidIt", text: "Field job Wo created by", headerAlign: "left", style: { textTransform: "capitalize", textAlign: 'center' } },
  ];

  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  return (
    <>
      <Formik initialValues={{}} onSubmit={() => {}}>
        {() => (
          <>
            <Row>
              <Col md={{ span: 3, order: 1 }} className="mb-3" xs={{ order: 2 }}>
                <div className="form-group">
                  <label>From Date</label>
                  <DatePicker
                    selected={fromDate}
                    onChange={handleFromDateChange}
                    dateFormat="dd-MMM-yyyy"
                    maxDate={new Date()}
                    className="form-control"
                    placeholderText="DD-MMM-YYYY"
                    showYearDropdown
                    scrollableYearDropdown
                  />
                </div>
              </Col>
              <Col md={{ span: 3, order: 2 }} className="mb-3" xs={{ order: 3 }}>
                <div className="form-group">
                  <label>To Date</label>
                  <DatePicker
                    selected={toDate}
                    onChange={handleToDateChange}
                    dateFormat="dd-MMM-yyyy"
                    minDate={fromDate}
                    maxDate={new Date()}
                    className="form-control"
                    placeholderText="DD-MMM-YYYY"
                    showYearDropdown
                    scrollableYearDropdown
                  />
                </div>
              </Col>
              <Col md={{ span: 3, order: 3 }} className="mb-3" xs={{ order: 4 }}>
                <button className="btn btn-secondary mt-lg-4" onClick={getFieldListByDate}>
                  <FontAwesomeIcon icon={faSearch} className="me-2" />
                  <span>Search By Date</span>
                </button>
              </Col>
              <Col md={{ span: 3, order: 4 }} className="mt-4" xs={{ order: 1 }}>
                {/* <div className="newadd" align="right">
                  <Link to="field-job" className="btn btn-secondary">
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    <span>Create Field Job WO</span>
                  </Link>
                </div> */}
              </Col>
            </Row>

            <ToolkitProvider
              keyField="id"
              search={true}
              columns={columns}
              data={entries}
              exportCSV={{ onlyExportFiltered: true, exportAll: false }}
            >
              {({ baseProps, csvProps }) => (
                <Paginator.PaginationProvider
                  pagination={Pagination({
                    custom: true,
                    disablePageTitle: true,
                    alwaysShowAllBtns: true,
                    totalSize: totalCount,
                    paginationTotalRenderer: customTotal,
                    onPageChange: handlePageChange,
                  })}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <Card>
                      <Col xs={12} md={6} className="p-2">
                        <h5 className="head">field job wo Entry list</h5>
                      </Col>
                      <div className="table-responsive py-2">
                        <Card.Header>
                          <Row>
                            <Col xs={12} md={6} className="py-1 md-3 d-flex ">
                              <input
                                type="search"
                                placeholder="Search by dispenser Sr No..."
                                value={searchDispenserSerialNumber}
                                onChange={(e) => setSearchDispenserSerialNumber(e.target.value)}
                                className="form-control-alternative form-control searchinput"
                                style={{ marginRight: "10px" }}
                              />
                              <button
                                className="btn btn-secondary"
                                onClick={searchPerformed ? clearSearch : search}
                              >
                                <FontAwesomeIcon
                                  icon={searchPerformed ? faTimes : faSearch}
                                  className="me-2"
                                />
                                <span>{searchPerformed ? "Clear Serial Number" : "Search By Serial Number"}</span>
                              </button>
                            </Col>
                            <Col xs={12} md={6} className="d-flex justify-content-md-end py-1">
                              <button
                                className="btn btn-secondary"
                                onClick={getFieldReportPdfDownloadHandler}
                              >
                                <FontAwesomeIcon icon={faDownload} className="me-2" />
                                <span>PDF</span>
                              </button>
                              <button
                                className="btn btn-secondary mx-2"
                                onClick={getFieldIssueExcelDownloadHandler}
                              >
                                <FontAwesomeIcon icon={faDownload} className="me-2" />
                                <span>Excel</span>
                              </button>
                            </Col>
                          </Row>
                        </Card.Header>

                        {isLoaded ? (
                          <div className="text-center bg-black text-white">
                            Please wait field job data is loading ...
                          </div>
                        ) : (
                          <BootstrapTable
                            {...baseProps}
                            {...paginationTableProps}
                            bodyClasses="border-0"
                            rowClasses="border-bottom"
                            classes="table-flush dataTable-table"
                            wrapperClasses="table-responsive"
                            filter={filterFactory()}
                            headerClasses="header-class"
                            hover
                            striped
                            condensed
                            remote={{ pagination: true }}
                            cellEdit={cellEditFactory({
                              mode: "click",
                              blurToSave: true,
                            })}
                          />
                        )}

                        <Card.Footer>
                          <Row>
                            <Col xs={12} md={6} className="d-flex align-items-center py-1"></Col>
                            <Col xs={12} md={6} className="d-flex justify-content-md-end align-items-center mb-0 py-1">
                              <Paginator.PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row>
                        </Card.Footer>
                      </div>
                    </Card>
                  )}
                </Paginator.PaginationProvider>
              )}
            </ToolkitProvider>
          </>
        )}
      </Formik>
    </>
  );
};
